import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";

import type { FeatureFlags } from "cortex/ui/src/integrations/featureFlags";
import { normalizeFeatureFlags } from "cortex/ui/src/integrations/featureFlags";

export function useFeatureFlag(): FeatureFlags;
export function useFeatureFlag(
  flagKey: string,
  defaultValue?: boolean,
): boolean;

export function useFeatureFlag(
  flagKey?: string,
  defaultValue: boolean = false,
) {
  const ldFlags = useFlags() as Record<string, unknown>;

  const featureFlags = useMemo<FeatureFlags>(
    () => normalizeFeatureFlags(ldFlags),
    [ldFlags],
  );

  return useMemo(() => {
    if (!flagKey) {
      return featureFlags;
    }

    const value = featureFlags[flagKey];
    return typeof value === "boolean" ? value : defaultValue;
  }, [featureFlags, flagKey, defaultValue]);
}
